// extracted by mini-css-extract-plugin
module.exports = {"basePlan":"BasePlan_basePlan_3wJw9"};